
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'base-input',
  inheritAttrs: false,
  props: {
    input: String,
    label: { type: String, required: true },
    error: { type: String, required: false },
    name: { type: String, required: true },
    placeholder: { type: String, required: false },
  },
  emits: ['update:input', 'click-trailing'],
  methods: {
    updateValue(value: string) {
      this.$emit('update:input', value)
    },
  },
  computed: {
    hasTrailing(): boolean {
      return !!this.$slots['trailing']
    },
  },
})
